import React, { Component, Fragment } from 'react';

import * as Func from '../../../../../../helpers/functions';
import {
    FormWrapperItem, ListComponent, StatusComponent,
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import { Collapse, Skeleton } from 'antd';
import { PointHistory } from '../../../../../../models/Order';

const { Panel } = Collapse;

const removedColumns = [
    'id', 'orderId', 'orderCode', 'createdDate','vgId', 'type','refundStatus', 'orderRefundStatus', 'refundBy', 'refundAt',
];
const saveLogItemKeys = Object.getOwnPropertyNames(new PointHistory());
export default class PointHistories extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable([...saveLogItemKeys], [], removedColumns),
            modelItem: saveLogItemKeys,
            componentTable: {
                PropertyCode: {
                },
                amount: {
                },
                sessionId: {
                },
                status: {
                    key: 'status',
                    render: (value, record) => {
                        return <Fragment>
                            <StatusComponent color={value ? 'green' : 'red'}
                                label={this.props.t(value ? `item.order.pointHistory.statusTypes.success` : `item.order.pointHistory.statusTypes.failed`)} />
                        </Fragment>
                    },
                }
            }
        };
    }

    render() {
        const { t, saveHistories, loading } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
                <Collapse className='my-3 w-100' style={{backgroundColor: "white"}} bordered={false} expandIconPosition='right'>
                    <Panel header={
                    <h3 className={`m-0`} style={{ color: "#676a6c" }}>{t('item.order.pointHistory.saveLog')}</h3>
                    } key="1">
                        <Wrapper className="col-md-12 sms-histories-section">
                            <Wrapper className={`row mt-2 mb-3`}>
                                <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
                                    {!loading ?
                                        <ListComponent
                                            classParent="m-0 p-0 col-md-12"
                                            marginTop={'0'} marginBottom={'0'}
                                            loading={{ spinning: loading, size: 'large' }}
                                            rowKey={(record, k) => k}
                                            dataSource={Func.getDataSource(saveHistories, modelItem)}
                                            columns={Func.columnsTable({
                                                titleTable: titleItemTable,
                                                component: componentTable,
                                                itemName: 'order.pointHistory'
                                            })}
                                            componentTableList={{}}
                                            hideSettings={true}
                                        />
                                        : <Skeleton active paragraph={{ row: 3 }} className="p-4" />
                                    }
                                </FormWrapperItem>
                            </Wrapper>
                        </Wrapper>
                    </Panel>
                </Collapse>

        );
    }
}

PointHistories.defaultProps = {
    saveHistories: [],
    loading: false,
};